export default {"src":"/_next/static/media/live-dangerously.2747f536.gif","height":202,"width":480,"blurWidth":0,"blurHeight":0};